// src/pages/browse/browseDataCache.ts
// Global cache to persist data between route changes
interface TableCache {
  data: any;
  filterConfig: any;
  visibleColumns: string[];
}

const tableDataCache: Record<string, TableCache> = {
  compounds: {
    data: null,
    filterConfig: {},
    visibleColumns: [],
  },
  complexes: {
    data: null,
    filterConfig: {},
    visibleColumns: [],
  },
  citations: {
    data: null,
    filterConfig: {},
    visibleColumns: [],
  }
};

export function getTableData(tableType: string) {
  return tableDataCache[tableType]?.data;
}

export function setTableData(tableType: string, data: any) {
  if (tableDataCache[tableType]) {
    tableDataCache[tableType].data = data;
  }
}

export function getFilterConfig(tableType: string) {
  return tableDataCache[tableType]?.filterConfig || {};
}

export function setFilterConfig(tableType: string, filterConfig: any) {
  if (tableDataCache[tableType]) {
    tableDataCache[tableType].filterConfig = filterConfig;
  }
}

export function getVisibleColumns(tableType: string) {
  return tableDataCache[tableType]?.visibleColumns || [];
}

export function setVisibleColumns(tableType: string, visibleColumns: string[]) {
  if (tableDataCache[tableType]) {
    tableDataCache[tableType].visibleColumns = visibleColumns;
  }
}

export function clearTableData() {
  Object.keys(tableDataCache).forEach(key => {
    tableDataCache[key].data = null;
    tableDataCache[key].filterConfig = {};
    tableDataCache[key].visibleColumns = [];
  });
}